import { rem } from 'polished'

import { css } from '../'
import { Size, SizeName } from '../size'

export interface HorizontalSpaceProps {
  paddingRight?: SizeName
  paddingLeft?: SizeName
}

export interface VerticalSpaceProps {
  paddingTop?: SizeName
  paddingBottom?: SizeName
}

export const horizontalSpaceCss = css`
  padding-right: ${(p: HorizontalSpaceProps) =>
    p.paddingRight && rem(Size[p.paddingRight])};

  padding-left: ${(p: HorizontalSpaceProps) =>
    p.paddingLeft && rem(Size[p.paddingLeft])};
`

export const verticalSpaceCss = css`
  padding-top: ${(p: VerticalSpaceProps) =>
    p.paddingTop && rem(Size[p.paddingTop])};

  padding-bottom: ${(p: VerticalSpaceProps) =>
    p.paddingBottom && rem(Size[p.paddingBottom])};
`
